import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './BannerImage.css';
import API_URL from '../../api/ExamCalendarApi';

const BannerImages = () => {
    const [bannerImages, setBannerImages] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showUploadModal, setShowUploadModal] = useState(false);

    // Fetch banner images from the server
    const fetchBannerImages = async () => {
        try {
            const response = await axios.get(`${API_URL}/homepage/banner-images`);
            setBannerImages(response.data.bannerImages);
        } catch (error) {
            console.error('Error fetching banner images', error);
        }
    };

    // Upload new banner image(s)
    const handleFileChange = (e) => {
        setSelectedFile(e.target.files);
    };

    const handleUpload = async () => {
        if (!selectedFile) return;
        
        const formData = new FormData();
        for (let i = 0; i < selectedFile.length; i++) {
            formData.append('bannerImages', selectedFile[i]);
        }
        
        try {
            await axios.post(`${API_URL}/homepage/add-banner-images`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setShowUploadModal(false);
            fetchBannerImages(); // Refresh the list after uploading
        } catch (error) {
            console.error('Error uploading banner images', error);
        }
    };

    // Delete a banner image
    const handleDelete = async (id) => {
        try {
            await axios.delete(`${API_URL}/homepage/banner-images/${id}`);
            fetchBannerImages(); // Refresh the list after deletion
        } catch (error) {
            console.error('Error deleting banner image', error);
        }
    };

    useEffect(() => {
        fetchBannerImages();
    }, []);

    return (
        <div className="admin-bannerimage-container">
            <button className="admin-bannerimage-upload-button" onClick={() => setShowUploadModal(true)}>
                Upload Banner Images
            </button>

            {/* Upload Modal */}
            {showUploadModal && (
                <div className="admin-bannerimage-modal-overlay">
                    <div className="admin-bannerimage-modal">
                        <div className="admin-bannerimage-modal-header">
                            <h2>Upload Banner Images</h2>
                            <button
                                className="admin-bannerimage-modal-close"
                                onClick={() => setShowUploadModal(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="admin-bannerimage-modal-body">
                            <input
                                type="file"
                                multiple
                                onChange={handleFileChange}
                                className="admin-bannerimage-file-input"
                            />
                        </div>
                        <div className="admin-bannerimage-modal-footer">
                            <button
                                className="admin-bannerimage-button admin-bannerimage-close-button"
                                onClick={() => setShowUploadModal(false)}
                            >
                                Close
                            </button>
                            <button
                                className="admin-bannerimage-button admin-bannerimage-upload-confirm"
                                onClick={handleUpload}
                            >
                                Upload
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="admin-bannerimage-row">
                {bannerImages.map((image) => (
                    <div key={image._id} className="admin-bannerimage-col">
                        <div className="admin-bannerimage-card">
                            <img src={image.url} alt="Banner" className="admin-bannerimage-image" />
                            <div className="admin-bannerimage-card-footer">
                                <button
                                    className="admin-bannerimage-delete-button"
                                    onClick={() => handleDelete(image._id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BannerImages;